import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { LogOut } from 'lucide-react';
import { fetchMe, logoutWithSession } from 'shared/api/sessionAuth';

const Navbar: React.FC = () => {
  const navigate = useNavigate();
  const [userName, setUserName] = useState('No Name');

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const me = await fetchMe();
        if (mounted) {
          setUserName(me.full_name || me.username);
        }
      } catch {
        if (mounted) {
          setUserName('No Name');
        }
      }
    })();
    return () => {
      mounted = false;
    };
  }, []);

  const handleLogout = async () => {
    try {
      await logoutWithSession();
    } finally {
      navigate('/manager/login');
    }
  };
  return (
    <div className="flex items-center space-x-4">
      <span className="font-medium text-gray-700">{userName} 様</span>
      <button
        className="p-2 text-gray-700 transition-colors rounded hover:bg-gray-200"
        title="ログアウト"
        onClick={handleLogout}
      >
        <LogOut className="w-6 h-6" />
      </button>
    </div>
  );
};

export default Navbar;
